import { useDispatch, useSelector } from "react-redux";
import {
    Button,
    Modal, ModalBody, ModalHeader
} from "reactstrap";
import Select from "react-select";
import { useState } from "react";
import { unSubscribeToCompetition } from "apis/competitions";
import {
 fetchCompetitions, showErrorNotification, showSuccessNotification 
} from "store/actions";

function UnSubscriptionModal({ open, onClose, t, comp, loadCompetitions }) {
    const dispatch = useDispatch();
    const { accounts } = useSelector(state => state.forex);
    const [tradingAccount, setTradingAccount] = useState(null);
    const [loading, setLoading] = useState(false);
    const subscribe = async () => {
        setLoading(true);
        const data = await unSubscribeToCompetition(tradingAccount, comp);
        if (data && data.isSuccess) {
            dispatch(showSuccessNotification("UnSubscribed to competition"));
            dispatch(fetchCompetitions());
            onClose();
        } else {
            dispatch(showErrorNotification(data.message));
        }
        setLoading(false);
    };
    return (<>
        <Modal isOpen={open} toggle={onClose} centered={true}>
            <ModalHeader toggle={onClose} tag="h4">
                {t("UnSubscribe")}
            </ModalHeader>
            <ModalBody>
                <Select
                  name="tradingAccount"
                  options={accounts?.accounts?.filter(
                    acc => acc?.accountTypeId?._id?.toString() === comp?.accountTypeId?.toString() && comp?.isSubscribed?.logins.includes(acc.login)
                    )?.map((val) => {
                        return {
                            label: `${val.login} ${val.platform} ${val.Balance}`,
                            value: val.login
                        };
                    })}
                  onChange={(val) => {
                        setTradingAccount(val.value);
                    }}
                >
                </Select>
                <div className="d-flex align-items-center justify-content-center">
                    <Button className="mt-4" onClick={() => {
                        subscribe();
                    }} disabled={loading}>
                        {t("Select Account")}
                    </Button>
                </div>
            </ModalBody>
        </Modal>
    </>);
}

export default UnSubscriptionModal;